import { render, staticRenderFns } from "./UserRate.vue?vue&type=template&id=ef908354&scoped=true"
import script from "./UserRate.vue?vue&type=script&lang=js"
export * from "./UserRate.vue?vue&type=script&lang=js"
import style0 from "./UserRate.vue?vue&type=style&index=0&id=ef908354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef908354",
  null
  
)

export default component.exports